import connectToStores from 'alt-utils/lib/connectToStores'
import { CheckActions } from 'actions'
import { CheckStore } from 'stores'
import { Authenticate } from 'common-frontend'
import Enum from 'utils/Enum'
import { API_BASE } from 'consts'

@connectToStores
export default class AuthenticateContainer extends React.Component {
  static contextTypes = {
    router: React.PropTypes.object.isRequired,
    currentUser: React.PropTypes.object
  }
  static propTypes = {
    initialMode: React.PropTypes.number,
    location: React.PropTypes.object.isRequired,
    resetToken: React.PropTypes.string
  }

  constructor(props) {
    super(props)
  }

  static getStores() {
    return [CheckStore]
  }

  static getPropsFromStores() {
    return CheckStore.getState()
  }

  componentDidUpdate() {
    if (this.props.checkActivated && this.props.checkActivated === true) {
      // note: we need to redirect to this because the CheckDetail is not fetched when activated
      this.context.router.push(`/checks/${Enum.CheckTypes.seoproblems.key}`)
    }
  }

  render() {
    return (
      <Authenticate initialMode={this.props.initialMode}
        location={this.props.location}
        onSignedUp={this.onSignedUp.bind(this)}
        resetToken={this.props.resetToken}
        onRequestShopifyAuth={this.onRequestShopifyAuth.bind(this)} />
    )
  }

  onSignedUp(params) {
    CheckActions.activate(Enum.CheckTypes.seoproblems.key, Enum.CheckTypes.seoproblems.id, { url: params.website }, this.context.currentUser)
  }

  onRequestShopifyAuth() {
    window.location = `${API_BASE}/login`
  }
}



// WEBPACK FOOTER //
// ./app/containers/AuthenticateContainer.js